import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import style from "./EuleriagymRombergEvaluationResults.module.sass";
import Select from "../Select/Select";
import EuleriagymBalanceEvaluationResult from "../EuleriagymBalanceEvaluationResults/EuleriagymBalanceEvaluationResult/EuleriagymBalanceEvaluationResult.js";


/**
 * EuleriagymRombergEvaluationResults
 * - Mostra i risultati del test di Romberg
 * - Gestisce selezione modalità/lato e visualizzazione occhi aperti/chiusi
 */
function EuleriagymRombergEvaluationResults(props) {
  const { color, exerciseName, rombergModalities, sideChooser,results, labels } = props;

  const [selectedResult, setSelectedResult] = useState({});


    useEffect(() => {
      setSelectedResult(optionsForSelect()[0]);
    }, [])
  // Costruisce le opzioni per la select (es: “1. Bipodalico”, “2. Tandem destro”)


 const optionsForSelect = () => {
    return results.map((result, index) => {
      return {
        value: result.modality,
        label: `${index + 1}. ${result.modality}`,
        key: index,
        result: result
      }
    })
  }


  




  return (
    <div className={style.rombergContainer}>
      <div className={style.resultSelectionTile}>
        <div className={style.exerciseName} style={{color: color}}>{exerciseName}</div>
        <div className={style.resultsSelect}>
          <Select
            options={optionsForSelect()}
            searchable={false}
            selectedOption={selectedResult.label}
            setOption={setSelectedResult}
          />
        </div>
      </div>

      <div className={style.resultContainer}>
        {selectedResult.result && (
          <div className={style.chartBlock}>
            <EuleriagymBalanceEvaluationResult
              anteroPosteriorChart={selectedResult.result.anteroPosteriorChart}
              bidimensionalChart={selectedResult.result.bidimensionalChart}
              duration={selectedResult.result.duration}
              maxDeviation={selectedResult.result.maxDeviation}
              midLateralChart={selectedResult.result.midLateralChart}
              percentages={selectedResult.result.percentages}
              rms={selectedResult.result.rms}
              sideChooser={sideChooser}
              sides={selectedResult.result.sides}
              sway={selectedResult.result.sway}
              isRomberg={true}
              labels={labels}
            />
          </div>
        )}


      </div>
    </div>
  );
}

EuleriagymRombergEvaluationResults.propTypes = {
  color: PropTypes.string,
  exerciseName: PropTypes.string,
  rombergModalities: PropTypes.array,
};

export default EuleriagymRombergEvaluationResults;
